import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

interface QRPrintPageProps {
  url: string;
  entityName: string;
  entityType: 'business' | 'trainer';
}

export function QRPrintPage({ url, entityName, entityType }: QRPrintPageProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, url, {
        width: 512,
        margin: 4,
        errorCorrectionLevel: 'M',
        color: { dark: '#1f2937', light: '#ffffff' },
      }).then(() => {
        // Auto-print after render
        setTimeout(() => window.print(), 500);
      });
    }
  }, [url]);

  return (
    <>
      <style>{`
        @media print {
          body { margin: 0 !important; padding: 0 !important; background: white !important; }
          .no-print { display: none !important; }
        }
      `}</style>
      <div className="min-h-screen flex flex-col items-center justify-center bg-white p-8">
        <div className="text-center">
          <p className="text-4xl font-bold text-blue-600 tracking-widest mb-8">SPOTTO</p>

          <canvas ref={canvasRef} className="mx-auto" />

          <p className="text-2xl font-bold text-gray-900 mt-8">{entityName}</p>

          <p className="text-lg text-gray-500 mt-3">
            {entityType === 'business'
              ? 'Zeskanuj kod QR aby zarezerwowac obiekt w aplikacji Spotto'
              : 'Zeskanuj kod QR aby zobaczyc treningi w aplikacji Spotto'}
          </p>

          <p className="text-sm text-gray-400 mt-6 break-all max-w-md mx-auto">{url}</p>
        </div>

        <button
          onClick={() => window.print()}
          className="no-print mt-8 px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
        >
          Drukuj
        </button>
      </div>
    </>
  );
}
